import type {WorldDocument} from '@private-fiction/story-core';
import {currentSceneLocation} from './sceneBackdrop';
export function resolveSceneAmbience(documents:readonly WorldDocument[]) {
  const location=currentSceneLocation(documents);
  const scene=documents.find(doc=>doc.kind==='scene'&&!doc.deletedAt&&(doc.runtimeState?.status??doc.fields.status)==='active');
  for(const file of [scene,location]) {
    const value=file?.fields.ambience;
    const ambience=value&&typeof value==='object'&&!Array.isArray(value)?value:null;
    const source=typeof value==='string'?value:typeof ambience?.url==='string'?ambience.url:typeof file?.fields.ambienceUrl==='string'?file.fields.ambienceUrl:'';
    if(source && /^(https?:\/\/|supabase-private:\/\/|gateway-private:\/\/story-assets\/|mvp-media:\/\/)/i.test(source)) return {source,fileId:file!.id,title:file!.title,volume:Math.max(0,Math.min(1,typeof ambience?.volume==='number'&&Number.isFinite(ambience.volume)?ambience.volume:.35)),loop:ambience?.loop!==false};
  }
  return null;
}
